<template>
  <v-flex class="sfh-login-header text-xs-center pa-1 "
    :class="$vuetify.breakpoint.name === 'xs' ? 'pt-2 pb-3':'pt-4'"
    :style="$vuetify.breakpoint.name === 'xs' ? '' : { paddingBottom: '35px !important' }"
    >
    <!-- For Sticky top --->
    <v-layout row align-center style="justify-content: space-evenly">
      <div
        :class="$vuetify.breakpoint.name === 'xs' ? 'flex xs2':''"
        class="text-xs-left px-2" >
        <img @click.stop="$store.commit('toggleLeftDrawer', true)"
             height="50"
             width="50"
             :src="appIcon"
             style="cursor:pointer;"
             :alt="appShortName" />
      </div>

      <v-flex xs7>
        <h2  class="white--text font-weight-regular float-left line-height-1"
             style="text-align: left;">
          <span v-text="appName"/>
        </h2>
      </v-flex>
      <v-flex xs3 text-xs-right>

        <v-toolbar-side-icon
          id="cogenti-sfh-logo"
          :class="currentStep === this.levelsCount ? 'current-step':''"
          class="ml-0" dark  @click.stop="$store.commit('toggleRightDrawer', true)"
        ></v-toolbar-side-icon>
      </v-flex>

    </v-layout>

    <navigation-menu></navigation-menu>
    <v-navigation-drawer
      temporary
      v-model="leftDrawer"
      app
      class="grey lighten-1"
    >
      <v-layout row text-xs-left>
        <v-flex xs12>
          <v-list class="grey lighten-3 pa-0">
            <v-list-group
              v-for="level in levels"
              :key="level.name"
              append-icon=""
              no-action
              style="border-bottom: 1px solid #bebebe;border-top: 1px solid #9c9c9c;"
              :disabled="Object.keys(level.memberLevel).length === 0"
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-chip :color="$store.getters['course/getLastPlayedLevel'] === level.id?'blue':'grey darken-1'" text-color="white"
                              label small class="ma-0 mb-2 pa-0">Level {{level.id}}</v-chip>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-if="Object.keys(level.memberLevel).length === 0">
                    <v-icon>lock</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-action v-else>
                    <v-rating
                      :title="Math.round(level.memberLevel.skillPercentage) < 12 ? '0% skill, use learn and quiz to build your skill' : ''"
                      length="4" readonly dense
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$vuetify.icons.ratingFull"
                      half-increments
                      hover
                      :value="getRating(Math.round(level.memberLevel.skillPercentage))"></v-rating>
                  </v-list-tile-action>
                </v-list-tile>
              </template>


              <v-list
                subheader dense class="pa-0"
              >
                <v-subheader class="level-title white" style="height:25px;"><strong>Level skill {{level.memberLevel.skillPercentage}}%</strong></v-subheader>

                <v-subheader class="level-title white" style="height:25px;">
                  <v-layout row align-center>
                    <v-flex xs1 style="padding-top:5px;">
                      <v-icon>chevron_right</v-icon></v-flex>
                    <v-flex xs11>&nbsp;Level coverage {{level.memberLevel.coveragePercentage}}%</v-flex>
                  </v-layout>
                </v-subheader>

                <v-subheader class="level-title white" style="height:25px;">
                  <v-layout row align-center>
                    <v-flex xs1 style="padding-top:5px;">
                      <v-icon>chevron_right</v-icon></v-flex>
                    <v-flex xs11>&nbsp;Level score {{level.memberLevel.scorePercentage}}%</v-flex>
                  </v-layout>
                </v-subheader>

              </v-list>
              <v-subheader style="height:auto;" class="white pt-1"><strong>Last quiz scores</strong>
                <div v-if="typeof level.levelTestScores === 'undefined' || level.levelTestScores.length === 0">
                  <em>Not found.</em></div>
                <v-list
                  v-for="(score, indexScore) in level.levelTestScores"
                  :key="indexScore"
                >

                  <div class="blue-grey--text text--darken-2 caption font-weight-bold">{{ score.score }}%</div>
                  <v-progress-linear

                    style="border-radius:5px;"
                    class="ma-0"
                    color="success"
                    background-color="grey lighten-3"
                    height="2"
                    :value="score.score"
                  ></v-progress-linear>

                </v-list>
              </v-subheader>
              <v-divider></v-divider>

            </v-list-group>
          </v-list>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
  </v-flex>
</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import PlainToolbar from './PlainToolbar'

  export default {
    name: 'ProgramLevelsHeader',
    props: ['navigationData'],
    components: {
      NavigationMenu, PlainToolbar
    },
    data () {
      return {
        listGroup: false,
        appIcon: require('@/assets/logos/' + process.env.APP_ICON),
        appName: process.env.APP_NAME,
        appShortName: process.env.APP_SHORT_NAME
      }
    },
    computed: {
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      leftDrawer: {
        get: function () {
          return this.$store.getters.leftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleLeftDrawer', value)
        }
      },
      levels () {
        return [...this.$store.getters['course/getLevels']]
      },
      levelsCount () {
        return this.$store.getters['getLevelsCount']
      }
    },
    methods: {
      getRating (skill) {
        if (skill === 100) return 4
        else if (skill > 87) return 3.5
        else if (skill > 75) return 3
        else if (skill > 62) return 2.5
        else if (skill > 50) return 2
        else if (skill > 37) return 1.5
        else if (skill > 25) return 1
        else if (skill > 12) return 0.5
        else if (skill < 12) return 0
      }
    },
    watch: {

    }
  }
</script>
<style scoped>
  .left_nav .v-list__group__header .v-list__group__header__prepend-icon{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/ProgramLevelsHeader.vue